module.exports = __webpack_public_path__ + "img/2.096d5360.png";